const routes = Object.freeze({
  LOGIN: '/login',
  BLOGS: '/blogs',
  DETAILS: '/detail',
  BATCHES: '/batches',
  STUDENT: '/students',
  ADD_EXAM: "/add-exam",
  BLOG_FORM: '/new-blog',
  ADD_BATCH: "/add-batch",
  ORDER: '/course-orders',
  BLOG_EDIT: '/blog/edit',
  DASHBOARD: '/dashboard',
  EDIT_EXAM: "/edit-exam",
  CONFIG: '/configuration',
  C_EDIT: '/coaching-edit',
  EDIT_BATCH: "/edit-batch",
  SUB_ADMINS: "/sub-admins",
  ADD_COURSE: "/add-course",
  CONTACT_US: '/contact-us',
  EXAM_ORDER: '/exam-orders',
  U_EDIT: '/university-edit',
  LEAD_DETAIL: '/lead-detail',
  MBBS_ABROAD: '/mbbs-abroad',
  EDIT_COURSE: "/edit-course",
  CALL_REQUEST: 'call-request',
  TESTIMONIAL: '/testimonials',
  BLOG_DETAIL: '/blogs/detail',
  PRODUCT_LIST: '/product/list',
  CUSTOM_PAGES: '/custom-pages',
  Edit_PRODUCT: '/product/edit',
  VIEW_PRODUCT: '/product/view',
  ADD_COACHING: "/add-coaching",
  HELP_SUPPORT: '/help-&-support',
  BATCH_ORDER: '/ordered-batches',
  ADD_UNIVERSITY: "/add-university",
  PARTNER_REVIEW: '/partner/review',
  CATALOGUE_MEAL: "/catalogue/meal",
  STUDENT_DETAILS: '/student/details',
  NEW_PRODUCT: '/product/new_product',
  NEW_CUSTOM_PAGE: '/new-custom-page',
  PARTNER_DETAILS: '/partner/details',
  AVAILABLE_EXAMS: '/available-exams',
  PARTNER_REQUEST: '/partner/requests',
  VIEW_TESTIMONIAL: '/testimonial/view',
  PARTNER_APPROVED: '/partner/approved',
  PARTNER_REJECTED: '/partner/rejected',
  COACHING_BLOCKED: '/coaching/blocked',
  EDIT_COACHING_BASIC: "/edit-coaching",
  APPLICATION_LIST: '/applications/list',
  COACHING_REVIEW_EDIT: '/coaching/edit',
  COACHING_REQUEST: '/coaching/requests',
  AVAILABLE_COURSES: '/available-courses',
  PARTNER_DOCUMENTS: '/partner/documents',
  COACHING_APPROVED: '/coaching/approved',
  COACHING_REJECTED: '/coaching/rejected',
  APPLICATION_DETAIL: '/application/detail',
  UNIVERSITY_BLOCKED: '/university/blocked',
  EDIT_UNIVERSITY_BASIC: "/edit-university",
  UNIVERSITY_REVIEW_EDIT: '/university/edit',
  UPLOAD: '/university/registrations/upload',
  COURSE: '/university/registrations/course',
  UNIVERSITY_REQUEST: '/university/requests',
  UNIVERSITY_APPROVED: '/university/approved',
  UNIVERSITY_REJECTED: '/university/rejected',
  HELP_SUPPORT_DETAIL: '/help-&-support/detail',
  CREATE_TESTIMONIAL: '/testimonial/create-new',
  PARTNER_REGISTRATION: '/partner/registrations',
  LGS_PENDING: '/lead-generation-system/pending',
  LGS_REJECTED: '/lead-generation-system/rejected',
  LGS_APPROVED: '/lead-generation-system/approved',
  COACHING_REGISTRATION: '/coaching/registrations',
  COACHING_UPLOAD: '/coaching/registrations/upload',
  COACHING_COURSE: '/coaching/registrations/course',
  COACHING_LISTING_FORM: '/coaching/registration/form',
  UNIVERSITY_REGISTRATION: '/university/registrations',
  INFORMATION: '/university/registrations/informations',
  PARTNER_DOCUMENTS_REVIEW: '/partner/documents/review',
  UNIVERSITY_LISTING_FORM: '/university/registration/form',
  COACHING_INFORMATION: '/coaching/registrations/informations',
  PLACEMENT_RECORD: '/university/registrations/placement-record',
  CREATE_COACHING: '/coaching/registrations/create-new-coaching',
  CREATE_UNIVERSITY: '/university/registrations/create-new-university',
});
export default routes;
